import mgp from './links/mgp';
import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  hideLinksMag = true;
  items = [];

  init(data) {
    if (+data.AgencyId === 2101) {
      this.items = mgp;
      if (data.IsSubAgent) {
        this.hideLinksMag = false;
      }
    }
    const omni = document.createElement('script');
    omni.src = 'https://static.mag.travel/template/script/omni.js';
    document.body.appendChild(omni);
    return Promise.resolve();
  }
}
